import React, { useEffect, useState } from 'react';
import { Dropdown } from 'primereact/dropdown';
import { Checkbox } from 'primereact/checkbox';
import { Badge } from 'primereact/badge';
import { Button } from 'primereact/button';
import './Permisos.scss';
import {
    getCollaborators,
    getModules,
    getModulesById,
    getPermisosTipo,
    getPermisosUsuario,
    updateJsonMenu,
    updatePermisions,
    updatePermisosUsuario,
} from './integracion';
import Swal from 'sweetalert2';
import ModalOrdenMenu from '../EditarMenu';
import { useMenu } from '../../../context/MenuContext';

const Permisos = () => {
    const [selectedPerson, setSelectedPerson] = useState(null);
    const [checkedPermissions, setCheckedPermissions] = useState({});
    const [checkedPermisosUsuario, setCheckedPermisosUsuario] = useState({});
    const [modules, setModules] = useState([]);
    const [people, setPeople] = useState([]);
    const [permisosTipo, setPermisosTipo] = useState([]);
    const [expandido, setExpandido] = useState({});
    const [editMenuVisible, setEditMenuVisible] = useState(false);
    const [guardando, setGuardando] = useState(false);
    const { menuData: jsonMenu, refreshMenu } = useMenu();

    useEffect(() => {
        const getData = async () => {
            setModules(await getModules());
            setPeople(await getCollaborators());
            setPermisosTipo(await getPermisosTipo());
        };
        getData();
    }, []);

    useEffect(() => {
        const getData = async () => {
            if (selectedPerson?.code == null) {
                Swal.fire({
                    title: 'Colaborador sin usuario',
                    text: 'añade un id_usuario a la tabla de colaborador',
                    icon: 'error',
                });
                return;
            }

            const [modulosGuardados, permisosGuardados] = await Promise.all([
                getModulesById(selectedPerson.code),
                getPermisosUsuario(selectedPerson.code),
            ]);

            setCheckedPermissions(modulosGuardados || {});
            setCheckedPermisosUsuario(permisosGuardados || {});
        };

        if (selectedPerson) getData();
    }, [selectedPerson]);

    const onPersonChange = (e) => {
        setSelectedPerson(e.value);
        setCheckedPermissions({});
        setCheckedPermisosUsuario({});
        setExpandido({});
    };

    // Checkbox de módulo (WEB_PERMISO)
    const onPermissionChange = (moduleCode, permission) => {
        const newCheckedPermissions = { ...checkedPermissions };
        const modulePermissions = newCheckedPermissions[moduleCode] || [];
        const seEstaDesmarcando = modulePermissions.includes(permission);

        newCheckedPermissions[moduleCode] = seEstaDesmarcando
            ? modulePermissions.filter((p) => p !== permission)
            : [...modulePermissions, permission];

        if (newCheckedPermissions[moduleCode].length === 0) {
            delete newCheckedPermissions[moduleCode];
        }

        setCheckedPermissions(newCheckedPermissions);

        // Si se desmarcó el módulo, también se limpian sus sub-permisos
        if (seEstaDesmarcando) {
            setCheckedPermisosUsuario((prev) => {
                const nuevo = { ...prev };
                delete nuevo[permission];
                return nuevo;
            });
        }
    };

    // Checkbox de sub-permiso (PERMISOS_USUARIO)
    const onPermisoUsuarioChange = (moduloId, permisoId, moduleCode) => {
        const moduloMarcado = (checkedPermissions[moduleCode] || []).includes(moduloId);
        if (!moduloMarcado) return; // no permite marcar sub-permisos sin el módulo activo

        const nuevo = { ...checkedPermisosUsuario };
        const actuales = nuevo[moduloId] || [];

        nuevo[moduloId] = actuales.includes(permisoId)
            ? actuales.filter((p) => p !== permisoId)
            : [...actuales, permisoId];

        if (nuevo[moduloId].length === 0) delete nuevo[moduloId];

        setCheckedPermisosUsuario(nuevo);
    };

    const permisosDelModulo = (moduloId) => permisosTipo.filter((pt) => pt.MODULO === moduloId);

    const toggleExpandido = (moduloId) => {
        setExpandido((prev) => ({ ...prev, [moduloId]: !prev[moduloId] }));
    };

    const savePermissions = async () => {
        if (!selectedPerson) {
            Swal.fire({ title: 'Selecciona una persona primero', icon: 'warning' });
            return;
        }
        if (selectedPerson?.code == null) {
            Swal.fire({
                title: 'Colaborador sin usuario',
                text: 'añade un id_usuario a la tabla de colaborador',
                icon: 'error',
            });
            return;
        }

        try {
            setGuardando(true);
            await Promise.all([
                updatePermisions(selectedPerson.code, checkedPermissions),
                updatePermisosUsuario(selectedPerson.code, checkedPermisosUsuario),
            ]);
        } finally {
            setGuardando(false);
        }
    };

    return (
        <div>
            <div className="service-panel__header shadow-2">
                <div className="flex flex-wrap justify-content-end align-items-center gap-3 md:p-3 mx-auto">
                    <div className="flex gap-2 flex-wrap">
                        <Button
                            label="Editar Menú"
                            icon="pi pi-pencil"
                            onClick={() => setEditMenuVisible(true)}
                            className="save-button"
                        />
                        <Button
                            label="Guardar Permisos"
                            icon="pi pi-save"
                            onClick={savePermissions}
                            className="save-button"
                            loading={guardando}
                        />
                    </div>
                </div>
            </div>

            <div className="permissions-manager-container">
                <div className="selection-section">
                    <label htmlFor="person-dropdown" className="label-style">Selecciona una persona:</label>
                    <Dropdown
                        id="person-dropdown"
                        value={selectedPerson}
                        options={people}
                        onChange={onPersonChange}
                        optionLabel="name"
                        placeholder="Seleccionar Persona"
                        className="person-dropdown"
                        filter
                    />
                </div>

                {selectedPerson?.code != null && (
                    <div className="modules-list-section">
                        <p className="modules-list-title">
                            Asignar permisos a: <span className="person-name">{selectedPerson.name}</span>
                        </p>
                        <div className="modules-container">
                            {modules?.map((module) => (
                                <div key={module.PADRE} className="module-item">
                                    <h3 className="module-header">{module.PADRE}</h3>
                                    {module.MODULOS.map((permission) => {
                                        const subPermisos = permisosDelModulo(permission.ID);
                                        const tieneSubPermisos = subPermisos.length > 0;
                                        const abierto = expandido[permission.ID];

                                        return (
                                            <div key={permission.ID} className="permission-item-group">
                                                <div
                                                    className="permission-item permission-item--modulo"
                                                    onClick={() => tieneSubPermisos && toggleExpandido(permission.ID)}
                                                >
                                                    <Checkbox
                                                        inputId={`${module.PADRE}-${permission.ID}`}
                                                        checked={(checkedPermissions[module.PADRE] || []).includes(permission.ID)}
                                                        onChange={() => onPermissionChange(module.PADRE, permission.ID)}
                                                        onClick={(e) => e.stopPropagation()}
                                                        className="permission-checkbox"
                                                    />
                                                    <label
                                                        htmlFor={`${module.PADRE}-${permission.ID}`}
                                                        className="permission-label"
                                                        onClick={(e) => e.stopPropagation()}
                                                    >
                                                        {permission.NOMBRE.charAt(0).toUpperCase() + permission.NOMBRE.slice(1)}
                                                    </label>

                                                    {tieneSubPermisos && (
                                                        <span className="sub-toggle">
                                                            <Badge value={subPermisos.length} severity="info" />
                                                            <i className={`pi pi-chevron-${abierto ? 'down' : 'right'}`} />
                                                        </span>
                                                    )}
                                                </div>

                                                {tieneSubPermisos && abierto && (
                                                    <div className="permisos-tipo-list">
                                                        {subPermisos.map((pt) => {
                                                            const moduloMarcado = (checkedPermissions[module.PADRE] || []).includes(permission.ID);

                                                            return (
                                                                <div key={pt.ID} className="permission-item permission-item--sub">
                                                                    <Checkbox
                                                                        inputId={`pt-${pt.ID}`}
                                                                        checked={(checkedPermisosUsuario[permission.ID] || []).includes(pt.ID)}
                                                                        onChange={() => onPermisoUsuarioChange(permission.ID, pt.ID, module.PADRE)}                                                                        disabled={!moduloMarcado}
                                                                        className="permission-checkbox"
                                                                    />
                                                                    <label
                                                                        htmlFor={`pt-${pt.ID}`}
                                                                        className={`permission-label permission-label--sub ${!moduloMarcado ? 'permission-label--disabled' : ''}`}
                                                                    >
                                                                        {pt.PERMISO.charAt(0).toUpperCase() + pt.PERMISO.slice(1).toLowerCase()}
                                                                    </label>
                                                                </div>
                                                            );
                                                        })}
                                                    </div>
                                                )}
                                            </div>
                                        );
                                    })}
                                </div>
                            ))}
                        </div>
                    </div>
                )}
            </div>

            <ModalOrdenMenu
                visible={editMenuVisible}
                onHide={() => setEditMenuVisible(false)}
                menuInicial={jsonMenu}
                onGuardar={async (data) => {
                    await updateJsonMenu(data.json);
                    await refreshMenu();
                    setEditMenuVisible(false);
                }}
            />
        </div>
    );
};

export default Permisos;
